export const CARD_IDENTITY: CardIdentity = 'CARD';

export type CardIdentity = 'CARD';

export const ENVIRONMENT = (() => {
  switch (process.env.NEXT_PUBLIC_ENV) {
    case 'dev':
    case 'develop':
    case 'development':
      return 'develop';
    case 'staging':
      return 'staging';
    case 'production':
      return 'production';
    default:
      return 'production';
  }
})();
